import React from 'react';
import { Container, Row, Col, Card, Button, Badge } from 'react-bootstrap';
import { FaGraduationCap, FaBriefcase } from 'react-icons/fa';

const MentorsList = () => {
  // Имитация данных из будущей БД
  const mentors = [
    { id: 1, name: "Азамат Алиев", job: "Инженер в Ошэлектро", year: 2010, tags: ["Энергетика", "Системы управления"] },
    { id: 2, name: "Айгуль Осмонова", job: "Senior Dev в IT-компании", year: 2018, tags: ["React", "Node.js", "Web Design"] },
    { id: 3, name: "Бакыт Тороев", job: "Начальник отдела в Мэрии", year: 2005, tags: ["Менеджмент", "Гос. управление"] },
  ];

  return (
    <Container className="py-5">
      <h2 className="fw-bold mb-4 text-center">Наши Менторы</h2>
      <Row className="g-4">
        {mentors.map(mentor => (
          <Col md={4} key={mentor.id}>
            <Card className="h-100 shadow-sm border-0 hover-shadow" style={{ transition: '0.3s' }}>
              <Card.Body>
                <h5 className="fw-bold text-primary">{mentor.name}</h5>
                <div className="small text-muted mb-2">
                  <FaBriefcase className="me-1" /> {mentor.job}
                </div>
                <div className="small text-muted mb-3">
                  <FaGraduationCap className="me-1" /> Выпускник {mentor.year} года
                </div>
                <div className="mb-3">
                  {mentor.tags.map(tag => (
                    <Badge bg="light" text="dark" className="me-1 border" key={tag}>{tag}</Badge>
                  ))}
                </div>
                <Button variant="outline-primary" className="w-100 rounded-pill">
                  Выбрать этого ментора
                </Button>
              </Card.Body>
            </Card>
          </Col>
        ))}
      </Row>
    </Container>
  );
};

export default MentorsList;